export enum QuizKey {
  QUIZ = 'quiz',
  QUIZ_PUBLIC = 'quizPublic',
  QUIZ_ATTEMPT = 'quizAttempt',
  QUIZZES_INFINITE = 'quizzesInfinite',
  ASSIGNED_QUIZZES = 'assignedQuizzes',
  ASSIGNED_QUIZZES_INFINITE = 'assignedQuizzesInfinite',
}
